export default __webpack_public_path__ + "static/media/Gallery5.bc21797c.jpg";